export default "__VITE_ASSET__FMww31Wn__"